import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenshotIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screenshot"}/>
}
